import type { ILanguageDto, ISiteDto, ITourDto } from '../../model/interface';
import type { IWorkspaceDB } from '../../db/interface';

export function ToursForLanguage(
    db: IWorkspaceDB,
    language: ILanguageDto,
    site?: ISiteDto,
): Promise<Array<ITourDto>> {
    return new Promise(async function (resolve, reject) {
        try {
            /* to get the list of tours we can show based on the language selected we need ITourDto.tourSupportedLanguage.siteSupportedLanguage.language === language */
            const sslMatch = await db
                .all('ISiteSupportedLanguageDto')
                .then(ssl => ssl.filter(x => x.languageId === language.id));
            const sslMatchIds = sslMatch.map(x => x.id);

            const tslMatch = await db
                .all('ITourSupportedLanguageDto')
                .then(tsl =>
                    tsl.filter(
                        x =>
                            sslMatchIds.includes(x.siteSupportedLanguageId) /* Workspace 1.0 */ ||
                            x.languageId === language.id /* Workspace 2.0 */,
                    ),
                );
            const tslMatchTourIds = tslMatch.map(x => x.tourId);

            const tours: ITourDto[] = await db
                .all('ITourDto')
                .then(tours => tours.filter(tour => tslMatchTourIds.includes(tour.id)));

            resolve(tours);
        } catch (error) {
            reject(error);
        }
    });
}

const module = {
    ToursForLanguage,
};

export default module;
